__turbopack_context__.v({
  "actions": "Header-module__zGz3HW__actions",
  "active": "Header-module__zGz3HW__active",
  "cartBadge": "Header-module__zGz3HW__cartBadge",
  "cartButton": "Header-module__zGz3HW__cartButton",
  "container": "Header-module__zGz3HW__container",
  "desktopNav": "Header-module__zGz3HW__desktopNav",
  "header": "Header-module__zGz3HW__header",
  "logo": "Header-module__zGz3HW__logo",
  "logoImage": "Header-module__zGz3HW__logoImage",
  "menuButton": "Header-module__zGz3HW__menuButton",
  "mobileNav": "Header-module__zGz3HW__mobileNav",
  "mobileNavLink": "Header-module__zGz3HW__mobileNavLink",
  "navLink": "Header-module__zGz3HW__navLink",
  "scrolled": "Header-module__zGz3HW__scrolled",
  "transparent": "Header-module__zGz3HW__transparent",
});
